import React from 'react';
import { InputNumber } from 'antd';

interface PropsType {
    value?: any;
    suffix?: any;
    style?: any;
}

const SPText: React.FC<PropsType> = (props) => {
    const { value, suffix, style } = props;

    return (
        <span style={style || {}}>{(value || '') + (suffix ? suffix : '')}</span>
    )
}

export default SPText
